module.exports = __webpack_public_path__ + "media/components/country-flag/static/rs-4b3d907ff6121bc57d149f66cf0f78cc.svg";